/**
 * The streak rule, shared by every session that keeps one (feature 023).
 *
 * A streak is a SIGNED RUN: positive for right answers in a row, negative for wrong ones. It
 * restarts at ±1 the moment the direction changes, which is what distinguishes it from a running
 * score — the score accumulates through zero, the run does not. "Two right after three wrong" is a
 * run of 2, not a score of −1, and the two numbers are shown together precisely because neither
 * substitutes for the other.
 *
 * Both practice surfaces call this rather than each spelling the arithmetic out, so the /problems
 * streak and the module-practice streak cannot drift apart.
 */
export function nextStreak(current: number, isCorrect: boolean): number {
  if (isCorrect) return current < 0 ? 1 : current + 1;
  return current > 0 ? -1 : current - 1;
}

/**
 * The best run of the visit so far.
 *
 * Floors at 0 by construction — the visit starts at 0 and `Math.max` keeps the previous value
 * against a negative streak, so a losing run can never be reported as a "best". A visit with no two
 * right answers in a row reports 0, which is true, rather than a personal worst.
 */
export function bestStreakSoFar(best: number, streak: number): number {
  return Math.max(best, streak);
}
